import { render, staticRenderFns } from "./PersonProfileAliasIdOverview.vue?vue&type=template&id=71b1a4a1&scoped=true&"
import script from "./PersonProfileAliasIdOverview.vue?vue&type=script&lang=js&"
export * from "./PersonProfileAliasIdOverview.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileAliasIdOverview.vue?vue&type=style&index=0&id=71b1a4a1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b1a4a1",
  null
  
)

export default component.exports